var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { Autocomplete, FormField } from '../../common';
export var SelectOrCustomField = function (_a) {
    var isCustom = _a.isCustom, control = _a.control, name = _a.name, value = _a.value, options = _a.options, getOptionDisabled = _a.getOptionDisabled, onSelectChange = _a.onSelectChange, onChange = _a.onChange, _b = _a.customValue, customValue = _b === void 0 ? '' : _b, customName = _a.customName, onCustomChange = _a.onCustomChange, onCustomBlur = _a.onCustomBlur, customPlaceholder = _a.customPlaceholder, defaultValue = _a.defaultValue, placeholder = _a.placeholder, maxLength = _a.maxLength, required = _a.required, error = _a.error, helperText = _a.helperText, _c = _a.disableClearable, disableClearable = _c === void 0 ? true : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    var _e = useState(customValue), localVal = _e[0], setLocalVal = _e[1];
    useEffect(function () {
        setLocalVal(customValue);
    }, [customValue]);
    var handleClear = function () {
        setLocalVal('');
        onCustomChange === null || onCustomChange === void 0 ? void 0 : onCustomChange('');
        onSelectChange === null || onSelectChange === void 0 ? void 0 : onSelectChange(defaultValue);
    };
    if (isCustom) {
        var customField = (_jsx(TextField, { fullWidth: true, size: "small", name: customName, value: localVal, onChange: function (e) {
                setLocalVal(e.target.value);
                onCustomChange === null || onCustomChange === void 0 ? void 0 : onCustomChange(e.target.value);
            }, onBlur: function (e) { return onCustomBlur === null || onCustomBlur === void 0 ? void 0 : onCustomBlur(e.target.value); }, onKeyDown: function (e) {
                // keep grid from stealing caret/selection keys
                e.stopPropagation();
                if (e.key === 'Enter') {
                    e.target.blur();
                }
            }, placeholder: customPlaceholder, autoComplete: "off", inputProps: { maxLength: maxLength, autoComplete: 'off' }, error: error, helperText: helperText, disabled: disabled, InputProps: {
                endAdornment: (_jsx(InputAdornment, __assign({ position: "end", sx: { mr: -1 } }, { children: _jsx(IconButton, __assign({ size: "small", edge: "end", onMouseDown: function (e) { return e.preventDefault(); }, onClick: handleClear, sx: { px: 2 }, disabled: disabled }, { children: _jsx(FontAwesomeIcon, { icon: faXmark }) })) }))),
            } }));
        return control ? (_jsx(FormField, __assign({ required: required, control: control, name: customName }, { children: customField }), customName)) : (customField);
    }
    var selectField = (_jsx(Autocomplete, { options: options, placeholder: placeholder, size: "small", value: value, onChange: onChange, disableClearable: disableClearable, disabled: disabled, error: error, getOptionDisabled: getOptionDisabled }));
    return control ? (_jsx(FormField, __assign({ required: required, control: control, name: name }, { children: selectField }), name)) : (selectField);
};
